import { render, staticRenderFns } from "./CreateReturn.vue?vue&type=template&id=2cbd070a"
import script from "./CreateReturn.vue?vue&type=script&lang=js"
export * from "./CreateReturn.vue?vue&type=script&lang=js"
import style0 from "./CreateReturn.vue?vue&type=style&index=0&id=2cbd070a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports